// 新手引导设备数据
import request from '@/utils/request';
export function bootDevices(data) {
  return request({
    url: '/data/boot_device',
    method: 'get',
    params: data
  });
}